import React from "react";
import Navbar from "./components/Navbar";
import BannerSlider from "./components/BannerSlider";
import ContactUs from "./components/ContactUs";
import AboutUs from "./components/AboutUs";
import Footer from "./components/Footer";
import Facilities from "./components/Facilities";
import Testimonials from "./components/Testimonials";
import WhatsAppButton from "./components/WhatsAppButton";
import GallerySlider from "./components/GallerySlider";
import Departments from "./components/Departments";
import { Helmet } from "react-helmet";
import Joblisting from "./components/Joblisting";
// import SlidingText from './components/SlidingText';

<Helmet>
  <title>Natraj Hospital - Bijoliya, Rajasthan</title>
  <meta name="description" content="नटराज हॉस्पिटल, बिजोलिया - उच्च गुणवत्ता वाली स्वास्थ्य सेवाएं और विशेषज्ञ डॉक्टरों की टीम।" />
  <meta name="keywords" content="Natraj Hospital, Hospital in Bijoliya, Health care Rajasthan, Gynecologist Bijoliya, General Physician, Orthopedic" />
  <meta name="author" content="Natraj Hospital" />
  <meta name="robots" content="index, follow" />
  <meta property="og:title" content="Natraj Hospital - Bijoliya" />
  <meta property="og:description" content="उच्च गुणवत्ता वाली स्वास्थ्य सेवाएं और विशेषज्ञ डॉक्टर।" />
  <meta property="og:image" content="https://www.natrajhospital.in/cover.jpg" />
  <meta property="og:url" content="https://www.natrajhospital.in.com/" />
  <meta name="twitter:card" content="summary_large_image" />

  <script type="application/ld+json">
{`
{
  "@context": "https://schema.org",
  "@type": "Hospital",
  "name": "Natraj Hospital",
  "image": "https://www.natrajhospital.com/cover.jpg",
  "address": {
    "@type": "PostalAddress",
    "streetAddress": "Teja Ji Ka Chowk",
    "addressLocality": "Bijoliya",
    "addressRegion": "Rajasthan",
    "postalCode": "311602",
    "addressCountry": "India"
  },
  "url": "https://www.natrajhospital.com/",
  "telephone": "+917976336371",
  "geo": {
    "@type": "GeoCoordinates",
    "latitude": "25.1520",
    "longitude": "75.2817"
  },
  "openingHours": "Mo-Sa 09:00-20:00"
}
`}
</script>
</Helmet>
const App = () => {
  return (
    <div className="font-sans scroll-smooth">
       <Navbar />
      <div id="home">
        <BannerSlider />
        {/* <SlidingText/> */}
        <WhatsAppButton />
      
      </div>
      <div id="About">
        <AboutUs />
      </div>
      <div id="Services">
        <Facilities />
      </div>
      <div id="Department">
        <Departments />
      </div>
      <div id="Gallery">
        <GallerySlider />
      </div>
      <Testimonials />
   
      <div id="jobs">
        <Joblisting />
       
      </div>
      <div id="contact">
        <ContactUs />
       
      </div>
      {/* <BannerSlider />
      
      <AboutUs /> */}
    
      {/* <Facilities />
      <GallerySlider /> */}
      
      {/* <ContactUs /> */}
      <Footer />
    </div>
  );
};

export default App;
